import { CampaignModule } from 'utils/i18n/TModules';

// Translation Keys And Paths
export const CampaignListTableKey = `CampaignListTable`;
export const TCampaignListTable = `${CampaignModule}:${CampaignListTableKey}`;

export const CampaignListPageKey = `CampaignListPage`;
export const TCampaignListPage = `${CampaignModule}:${CampaignListPageKey}`;

export const CampaignCreatePageKey = `CampaignCreatePage`;
export const TCampaignCreatePage = `${CampaignModule}:${CampaignCreatePageKey}`;

export const CampaignReviewPageKey = `CampaignReviewPage`;
export const TCampaignReviewPage = `${CampaignModule}:${CampaignReviewPageKey}`;
